// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-module__aboutContainer__GjzQN {
    min-height: 100vh;
    display: grid;
    grid-template-rows: 2fr repeat(4, min-content);
    justify-self: center;
    margin-top: 6rem;
    margin-bottom: 3rem;
}

.about-module__title__rnP5a {
    letter-spacing: 0.4rem;
    font-size: 1rem;
    margin: 0 6rem;
    margin-bottom: 2rem;
    color: var(--color-green-faint);
}

.about-module__aboutMd__Dodm4 {
    margin: 0;
    border-bottom: 1px solid var(--color-border);
}

.about-module__aboutMd__Dodm4>div:nth-child(2) {
    margin: 0 6rem;
    font-size: 6rem;
    color: var(--color-green);
}

.about-module__aboutMd__Dodm4>div:last-child {
    margin: 0 6rem;
    margin-bottom: 4rem;
    font-size: 6rem;
    color: var(--color-cyan);
}

.about-module__readmeTxt__Re1x2 {
    margin: 0 6rem;
    padding: 2rem;
    border-left: 1px solid var(--color-border);
    border-right: 1px solid var(--color-border);
    border-bottom: 1px solid var(--color-border);
    border-radius: 1rem;
    background-color: var(--color-bg-secondary);

    display: grid;
    grid-template: min-content 1fr / 1fr 1fr;
}

.about-module__readmeTxt__Re1x2>div:first-child {
    font-size: 1rem;
    margin-bottom: 2rem;
    letter-spacing: 0.4rem;
    color: var(--color-green-faint);
}

.about-module__readmeTxt__Re1x2>div:nth-child(2) {
    grid-row: 2;
    grid-column: 1 / 3;
    line-height: 2.4rem;
    color: var(--color-green-muted);
}

.about-module__readmeTxt__Re1x2>div:last-child {
    justify-self: end;
    color: var(--color-green-faint);
    font-size: 1rem;
    letter-spacing: 0.4rem;
}

.about-module__mission__E4rQS>div:last-child,
.about-module__kitchen__y_6FZ>div:last-child {
    margin: 0 6rem;
    border: 1px solid var(--color-border);
    border-radius: 1rem;
    background-color: var(--color-bg-secondary);

    display: grid;
    grid-auto-flow: column;
}

.about-module__mission__E4rQS>div:last-child>div:nth-child(2) {
    border-left: 1px solid var(--color-border);
    border-right: 1px solid var(--color-border);
}

.about-module__mission__E4rQS>div:last-child>div>div:nth-child(n+2) {
    color: var(--color-green);
}

.about-module__kitchen__y_6FZ,
.about-module__mission__E4rQS,
.about-module__certification__Nm2Fp {
    margin-top: 6rem;
}

.about-module__kitchen__y_6FZ>div:last-child {
    grid-template: 1fr 1fr / 1fr 1fr;
}

.about-module__kitchen__y_6FZ>div:last-child>div,
.about-module__mission__E4rQS>div:last-child>div {
    padding: 2rem;
}

.about-module__kitchen__y_6FZ>div:last-child>div:nth-child(-n+2) {
    border-right: 1px solid var(--color-border);
}

.about-module__kitchen__y_6FZ>div:last-child>div:nth-child(odd) {
    border-bottom: 1px solid var(--color-border);
}

.about-module__kitchen__y_6FZ>div:last-child>div>div:first-child,
.about-module__mission__E4rQS>div:last-child>div>div:first-child {
    font-size: 1rem;
    letter-spacing: 0.2rem;
    color: var(--color-cyan-dim);
    margin-bottom: 1rem;
}

.about-module__certification__Nm2Fp>div:last-child {
    margin: 0 6rem;

    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
}

.about-module__certification__Nm2Fp>div:last-child>div {
    border: 1px solid var(--color-border);
    background-color: var(--color-bg-secondary);
    padding: 1rem;
}

.about-module__certification__Nm2Fp>div:last-child>div:nth-child(odd) {
    color: var(--color-green);
    border: 1px solid var(--color-green-faint);
}

.about-module__certification__Nm2Fp>div:last-child>div:nth-child(2) {
    color: var(--color-cyan-dim);
    border: 1px solid var(--color-cyan-dim);
}`, "",{"version":3,"sources":["webpack://./src/pages/about/about.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,8CAA8C;IAC9C,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,SAAS;IACT,4CAA4C;AAChD;;AAEA;IACI,cAAc;IACd,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,0CAA0C;IAC1C,2CAA2C;IAC3C,4CAA4C;IAC5C,mBAAmB;IACnB,2CAA2C;;IAE3C,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,eAAe;IACf,sBAAsB;AAC1B;;AAEA;;IAEI,cAAc;IACd,qCAAqC;IACrC,mBAAmB;IACnB,2CAA2C;;IAE3C,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,0CAA0C;IAC1C,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;IAGI,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,4CAA4C;AAChD;;AAEA;;IAEI,eAAe;IACf,sBAAsB;IACtB,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,cAAc;;IAEd,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,qCAAqC;IACrC,2CAA2C;IAC3C,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,0CAA0C;AAC9C;;AAEA;IACI,4BAA4B;IAC5B,uCAAuC;AAC3C","sourcesContent":[".aboutContainer {\n    min-height: 100vh;\n    display: grid;\n    grid-template-rows: 2fr repeat(4, min-content);\n    justify-self: center;\n    margin-top: 6rem;\n    margin-bottom: 3rem;\n}\n\n.title {\n    letter-spacing: 0.4rem;\n    font-size: 1rem;\n    margin: 0 6rem;\n    margin-bottom: 2rem;\n    color: var(--color-green-faint);\n}\n\n.aboutMd {\n    margin: 0;\n    border-bottom: 1px solid var(--color-border);\n}\n\n.aboutMd>div:nth-child(2) {\n    margin: 0 6rem;\n    font-size: 6rem;\n    color: var(--color-green);\n}\n\n.aboutMd>div:last-child {\n    margin: 0 6rem;\n    margin-bottom: 4rem;\n    font-size: 6rem;\n    color: var(--color-cyan);\n}\n\n.readmeTxt {\n    margin: 0 6rem;\n    padding: 2rem;\n    border-left: 1px solid var(--color-border);\n    border-right: 1px solid var(--color-border);\n    border-bottom: 1px solid var(--color-border);\n    border-radius: 1rem;\n    background-color: var(--color-bg-secondary);\n\n    display: grid;\n    grid-template: min-content 1fr / 1fr 1fr;\n}\n\n.readmeTxt>div:first-child {\n    font-size: 1rem;\n    margin-bottom: 2rem;\n    letter-spacing: 0.4rem;\n    color: var(--color-green-faint);\n}\n\n.readmeTxt>div:nth-child(2) {\n    grid-row: 2;\n    grid-column: 1 / 3;\n    line-height: 2.4rem;\n    color: var(--color-green-muted);\n}\n\n.readmeTxt>div:last-child {\n    justify-self: end;\n    color: var(--color-green-faint);\n    font-size: 1rem;\n    letter-spacing: 0.4rem;\n}\n\n.mission>div:last-child,\n.kitchen>div:last-child {\n    margin: 0 6rem;\n    border: 1px solid var(--color-border);\n    border-radius: 1rem;\n    background-color: var(--color-bg-secondary);\n\n    display: grid;\n    grid-auto-flow: column;\n}\n\n.mission>div:last-child>div:nth-child(2) {\n    border-left: 1px solid var(--color-border);\n    border-right: 1px solid var(--color-border);\n}\n\n.mission>div:last-child>div>div:nth-child(n+2) {\n    color: var(--color-green);\n}\n\n.kitchen,\n.mission,\n.certification {\n    margin-top: 6rem;\n}\n\n.kitchen>div:last-child {\n    grid-template: 1fr 1fr / 1fr 1fr;\n}\n\n.kitchen>div:last-child>div,\n.mission>div:last-child>div {\n    padding: 2rem;\n}\n\n.kitchen>div:last-child>div:nth-child(-n+2) {\n    border-right: 1px solid var(--color-border);\n}\n\n.kitchen>div:last-child>div:nth-child(odd) {\n    border-bottom: 1px solid var(--color-border);\n}\n\n.kitchen>div:last-child>div>div:first-child,\n.mission>div:last-child>div>div:first-child {\n    font-size: 1rem;\n    letter-spacing: 0.2rem;\n    color: var(--color-cyan-dim);\n    margin-bottom: 1rem;\n}\n\n.certification>div:last-child {\n    margin: 0 6rem;\n\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n}\n\n.certification>div:last-child>div {\n    border: 1px solid var(--color-border);\n    background-color: var(--color-bg-secondary);\n    padding: 1rem;\n}\n\n.certification>div:last-child>div:nth-child(odd) {\n    color: var(--color-green);\n    border: 1px solid var(--color-green-faint);\n}\n\n.certification>div:last-child>div:nth-child(2) {\n    color: var(--color-cyan-dim);\n    border: 1px solid var(--color-cyan-dim);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"aboutContainer": `about-module__aboutContainer__GjzQN`,
	"title": `about-module__title__rnP5a`,
	"aboutMd": `about-module__aboutMd__Dodm4`,
	"readmeTxt": `about-module__readmeTxt__Re1x2`,
	"mission": `about-module__mission__E4rQS`,
	"kitchen": `about-module__kitchen__y_6FZ`,
	"certification": `about-module__certification__Nm2Fp`
};
export default ___CSS_LOADER_EXPORT___;
